import {useTranslation} from "react-i18next";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

// Define las rutas de las imágenes
const pngPaths = {
    1: "/images/icons/unloads-levels/1-vibration-128-orange.png",
    2: "/images/icons/unloads-levels/2-empty-bin-128-green.png",
    4: "/images/icons/unloads-levels/4-manual-128-blue.png",
    // Nota: No tienes una ruta definida para el nivel 3,
    // tu lógica original intentaba usar icons[2] e icons[3]
};

// Crea un componente pequeño para renderizar el icono correcto
const IconCardForLevel = ({level}) => {
    const {t: _Tc} = useTranslation("choices");
    // Estilos opcionales para controlar el tamaño
    const urlStatic = process.env?.REACT_APP_STATIC_URL || "/static";
    switch (parseInt(level)) {
        case 1:
            return (
                <div>
                    <img src={urlStatic + pngPaths[1]} alt="1" /> <span className="ms-2">{_Tc("alerts_types.sm")}</span>
                </div>
            );
        case 2:
            return (
                <div>
                    <img src={urlStatic + pngPaths[2]} alt="2" /> <span className="ms-2">{_Tc("alerts_types.ed")}</span>
                </div>
            );
        case 3:
            return (
                <>
                    <div>
                        <img src={urlStatic + pngPaths[1]} alt="1" /> <span className="ms-2">{_Tc("alerts_types.sm")}</span>
                    </div>
                    <div>
                        <img src={urlStatic + pngPaths[2]} alt="2" /> <span className="ms-2">{_Tc("alerts_types.ed")}</span>
                    </div>
                </>
            );
        case 4:
            return (
                <div>
                    <img src={urlStatic + pngPaths[4]} alt="4" /> <span className="ms-2">{_Tc("alerts_types.mn")}</span>
                </div>
            );
        case 5:
            return (
                <div>
                    <FontAwesomeIcon icon="truck-field" className="text-success me-2" /> <span>Truck</span>
                </div>
            );
        default:
            // No renderizar nada si el nivel no coincide
            return null;
    }
};

// Ya no necesitas exportar setIcons o getIcon de la forma anterior
export default IconCardForLevel;
